var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMainAccount } from "@ledgerhq/coin-framework/account/index";
import { calculateAmount } from "./logic";
import getEstimatedFees from "./js-getFeesForTransaction";
import createTransaction from "./js-createTransaction";
import { loadPolkadotCrypto } from "./polkadot-crypto";
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
const estimateMaxSpendable = (polkadotAPI) => ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    yield loadPolkadotCrypto();
    const a = getMainAccount(account, parentAccount);
    const t = Object.assign(Object.assign(Object.assign({}, createTransaction()), transaction), { useAllAmount: true });
    const fees = yield getEstimatedFees(polkadotAPI)({
        a,
        t,
    });
    return calculateAmount({
        a,
        t: Object.assign(Object.assign({}, t), { fees }),
    });
});
export default estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map